module.exports = __webpack_public_path__ + "r-v3/img/userCount_white.4baef72b.svg";